import * as __WEBPACK_EXTERNAL_MODULE__variants_index_js_e33e4e91__ from "../../variants/index.js";
import * as __WEBPACK_EXTERNAL_MODULE__variants_tv_js_3968a67e__ from "../../variants/tv.js";
const iconAVariants = (0, __WEBPACK_EXTERNAL_MODULE__variants_tv_js_3968a67e__.tv)({
    slots: __WEBPACK_EXTERNAL_MODULE__variants_index_js_e33e4e91__.iconButtonSlots,
    variants: {
        type: __WEBPACK_EXTERNAL_MODULE__variants_index_js_e33e4e91__.iconButtonTypeVariants,
        size: __WEBPACK_EXTERNAL_MODULE__variants_index_js_e33e4e91__.iconButtonSizeVariants,
        emphasis: __WEBPACK_EXTERNAL_MODULE__variants_index_js_e33e4e91__.iconButtonEmphasisVariants,
        shadow: __WEBPACK_EXTERNAL_MODULE__variants_index_js_e33e4e91__.iconButtonShadowVariants,
        disabled: __WEBPACK_EXTERNAL_MODULE__variants_index_js_e33e4e91__.iconButtonDisabledVariants
    },
    compoundVariants: __WEBPACK_EXTERNAL_MODULE__variants_index_js_e33e4e91__.iconButtonCompoundVariants,
    defaultVariants: {
        type: 'secondary',
        emphasis: 'regular',
        size: 'md'
    }
});
export { iconAVariants };
